import React, { useState, useEffect } from "react";
import axios from "axios";
import { auth, db } from "../../firebase";
import { doc, setDoc } from "firebase/firestore";
import styleClasses from "./css/MyPage.module.scss";

function ImportEvents() {
  // KCISA events 관련 상태 (키워드 기반 검색)
  const [keyword, setKeyword] = useState("");
  const [kcisaEvents, setKcisaEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uid, setUid] = useState(null);
  const [authToken, setAuthToken] = useState("");

  const striptags = require("striptags");
  const he = require("he");

  // Firebase 로그인 상태 감지 및 토큰 저장
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setUid(user.uid);
        const token = await user.getIdToken();
        setAuthToken(token);
      }
    });
    return () => unsubscribe();
  }, []);

  // KCISA 이벤트 데이터를 가져오는 함수 (keyword 기반)
  const fetchKcisaEvents = async () => {
    if (!keyword) {
      alert("검색할 키워드(keyword)를 입력하세요.");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(
        "https://music-api-134893551192.asia-northeast3.run.app/api/activity/kcisaEvents",
        {
          params: { keyword },
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      console.log("🎶 KCISA events API 응답 데이터:", response.data);
      let items = response.data.activities;
      if (!items) {
        items = [];
      }
      if (!Array.isArray(items)) {
        items = [items];
      }
      // 각 이벤트 정보를 원하는 필드로 매핑
      const mapped = items.map((item, index) => ({
        id: item.id || `${item.title}_${index}`,
        title: item.title ? he.decode(striptags(item.title)) : "",
        description: item.description ? striptags(he.decode(item.description)) : "",
        link: item.link || "",
        channel: item.channel || "", // channel는 sourceTitle 값으로 매핑되어 있다고 가정
        date: item.date ? item.date.split(" ~ ")[0] : "",
    }));
      setKcisaEvents(mapped);
    } catch (error) {
      console.error("❌ KCISA events API 호출 실패:", error.response?.data || error.message);
      alert("KCISA 이벤트 검색 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };

  // Firestore에 활동 정보를 저장 (공통 함수)
  const handleAddActivity = async (activity) => {
    if (!uid) {
      alert("로그인이 필요합니다.");
      return;
    }
    try {
      const activityRef = doc(db, "users_data", uid, "activity", activity.id);
      const activityData = {
        title: activity.title,
        date: activity.date.split("T")[0] || activity.date,
        description: activity.description || "",
        channel: `[기타] ${activity.channel}`,
        channelType: "기타",
        photo: activity.photo || "",
        link: activity.link || "",
        createdAt: new Date().toISOString(),
      };
      await setDoc(activityRef, activityData);
      alert(`"${activity.title}" 활동이 아카이브에 추가되었습니다.`);
    } catch (error) {
      console.error("❌ 활동 저장 실패:", error);
      alert("활동 추가 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className={styleClasses.addActivityPage}>
      <h1>행사 가져오기</h1>

      {/* KCISA 이벤트 검색 섹션 */}
      <div className={styleClasses.searchBox}>
        <h2>KCISA 행사 검색</h2>
        <p>검색할 키워드(keyword)를 입력하세요.</p>
        <div className="formRow">
          <div className={styleClasses.inputField}>
            <input
              type="text"
              placeholder="키워드 입력"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </div>
        </div>
        <button onClick={fetchKcisaEvents} disabled={loading}>
          {loading ? "검색 중..." : "KCISA 행사 검색"}
        </button>
      </div>

      {/* 이벤트 목록 나열 */}
      <div className={styleClasses.activityList}>
        {kcisaEvents.length > 0 ? (
          kcisaEvents.map((activity) => (
            <div key={`kcisa-${activity.id}`} className={styleClasses.activityCard}>
              <div className={styleClasses.activityHeader}>
                {/* photo가 없는 경우 기본 이미지 처리 가능 */}
                {activity.photo && (
                  <img src={activity.photo} alt="활동 썸네일" />
                )}
                <p>제목: {activity.title}</p>
                <p>출처: {activity.channel}</p>
                <p>일자: {activity.date}</p>
              </div>
              {activity.description && (
                <div className={styleClasses.activityDescription}>
                  <p>{activity.description}</p>
                </div>
              )}
              <button onClick={() => handleAddActivity(activity)}>
                아카이브에 추가
              </button>
            </div>
          ))
        ) : (
          <p>검색 결과가 없습니다.</p>
        )}
      </div>
    </div>
  );
}

export default ImportEvents;